import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Text } from 'components/core/Typography';

import './BasicsCard.scss';

export default function BasicsCard({ header, children, className }) {
	return (
		<div className={classnames('basic-card', className)}>
			<div className="card-header">
				<Text
					last
					size="medium"
					color="white"
				>
					{header}
				</Text>
			</div>
			<div className="card-content">{children}</div>
		</div>
	);
}

BasicsCard.propTypes = {
	header: PropTypes.node,
	children: PropTypes.node,
	className: PropTypes.string,
};
